import React from "react";
import { Table, Link } from "@backstage/core-components";
export const IssuesTable = ({ issues, pageUrl }) => {
    const columns = [
        { title: "Severity", field: "severity" },
        { title: "ID", field: "id" },
        { title: "Type", field: "type" },
        { title: "Status", field: "status" },
        { title: "Description", field: "description" },
        { title: "Priority Score", field: "priority" },
    ];
    const data = issues.map((issue) => {
        var _a;
        const deepLinkToIssue = React.createElement(Link, { to: `${pageUrl}#issue-${issue.attributes.key}` },
            issue.attributes.key.substring(0, 35),
            "...");
        return {
            severity: issue.attributes.effective_severity_level,
            id: deepLinkToIssue,
            type: issue.attributes.type,
            status: issue.attributes.status,
            description: issue.attributes.title,
            priority: ((_a = issue.attributes.priority) === null || _a === void 0 ? void 0 : _a.score) || "",
        };
    });
    return (React.createElement(Table, { title: "Security vulnerabilities", options: { search: false, paging: false }, columns: columns, data: data }));
};
//# sourceMappingURL=SnykIssuesComponent.js.map